var React = require('react');

function Available (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","fill":"none","key":0}),React.createElement("g",{"transform":"translate(2 5)","key":1},React.createElement("path",{"d":"M17.781,27.319,23.6,33.134,33.781,22.949","transform":"translate(-17.781 -22.949)","fill":"none","stroke":"#0c2340","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"}))]);
}

Available.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Available;

Available.default = Available;
